<template>
  <!-- Using a blank `icon=""` attribute below changes the button's shape, while we pass an icon in -->
  <v-btn
    icon=""
    :ripple="ripple"
    :size="size"
    :to="to"
    :variant="variant"
  >
    <slot>
      <vi-icon
        v-if="icon"
        :icon="icon"
        :size="iconSize"
      />
    </slot>
  </v-btn>
</template>

<script setup lang="ts">
defineProps<{
  icon?: string
  size?: string | number
  iconSize?: string | number
  variant?: 'flat' | 'text' | 'elevated' | 'tonal' | 'outlined' | 'plain'
  to?: string
  ripple?: boolean | { class: string }
}>();
</script>
